export function btSettings (settings = {}) {
  return Object.assign({api_user: '', environment: 'sandbox', payment_type: '2phase', has_api_password: false}, settings, {api_password: ''})
}

export function btStatusKey (status) {
  return ['created', 'pending', 'captured', 'failed', 'expired', 'reversed', 'refunded', 'authorized', 'partial'][Number(status)] || 'unknown'
}

export function btApiError (response, fallback) {
  const body = response && response.error && response.error.response
    ? response.error.response.data : response
  if (!body) return fallback
  if (body.errors && typeof body.errors === 'object') {
    return Object.keys(body.errors).map(key => [].concat(body.errors[key]).join(' ')).join(' ')
  }
  return body.message || (typeof body.error === 'string' ? body.error : fallback)
}

export function btAmount (minor, currency) {
  const value = Number(minor)
  return (Number.isFinite(value) ? (value / 100).toFixed(2) : '—') + ' ' + currency
}



// WEBPACK FOOTER //
// ./src/utils/btPayments.js